import { StyledButton } from './button/style'
import SpinnerUI from './spinner/Spinner'
import CheckboxUI from './checkbox/Checkbox'
import { StyledImage } from './image/style'
import { StyledText } from './text/style'
import { StyledPane } from './pane/style'
import { StyledTitle } from './title/style'

export const Button = StyledButton
export const Spinner = SpinnerUI
export const Checkbox = CheckboxUI
export const Image = StyledImage
export const Text = StyledText
export const Pane = StyledPane
export const Title = StyledTitle
